const DataCombiner = (productData, projectDetails, patternDetails, productElements, configuratorState, summary) => {
    const combineProductData = () => {
        let data = {
            product: productData,
            currency: projectDetails.currency,
            quantity: projectDetails.quantity,
            quoteItemId: projectDetails.quoteItemId,
            type: projectDetails.projectType,
            projectName: projectDetails.projectName,
            quoteId: projectDetails.quoteId,
            catalog_number: summary.catalog_number,
            quickship: configuratorState.quickshipInt,
            total_price: summary.total_price.match(/[0-9\.]/g).join(""),
            book_price: summary.price.match(/[0-9\.]/g).join(""),
            line_number: projectDetails.lineNumber ? projectDetails.lineNumber : 1,
            country: projectDetails.country,
            language: projectDetails.language,
            price_book: projectDetails.priceBook,
            price_terms: projectDetails.priceTerms,
            commission_percent: projectDetails.commissionPercent,
            overage_commission_percent: projectDetails.overageCommissionPercent,
            freight_terms: projectDetails.freightTerms
        };
        if(configuratorState.isPattern){
            data = Object.assign(data, combinePatternData());
        } else if(configuratorState.hasElements){
            data = Object.assign(data, combineElementData());
        }
        return data;
    }

    const combinePatternData = () => {
        const prod = Object.assign({}, productData, {
            groupId: patternDetails.groupId,
            pattern_code: patternDetails.patternCode,
        })

        return {
            product: prod,
            isPattern: configuratorState.isPattern,
            patternId: productData.id,
            groupId: patternDetails.groupId,
            leg_catalog_numbers: summary.leg_catalog_numbers
        }
    }

    const combineElementData = ()  => {
        const prod = Object.assign({}, productData, {
            groupId: patternDetails.groupId,
            pattern_code: patternDetails.patternCode,
            elements_with_selections:  combineElementSideData(),
        })

        return {
            product: prod,
            hasElements: configuratorState.hasElements,
            groupId: patternDetails.groupId,
            elementSaveShouldUpdate: configuratorState.elementSaveShouldUpdate,
            element_group_catalog_number: summary.catalog_number,
            elementGroupId: projectDetails.elementGroupId,
            element_catalog_numbers: summary.element_summary
        }
    }

    const combineElementSideData = () => {
        const elementSummary = summary.element_summary;
        const combined = [];
        productElements.elements_with_selections.forEach((el, index) => {
            const withPriceAndData = Object.assign({}, el , {
                quickship: configuratorState.quickshipInt,
                unit_price: elementSummary[index].unit_price,
                total_price: elementSummary[index].total_price,
                catalog_number: elementSummary[index].catalog_number
            })
            combined.push(withPriceAndData);
        })

        return combined;
    }

    return combineProductData();

}

export default DataCombiner;